import React from "react";
const IconShow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M19 10C19 10 13.866 16 10 16C6.13401 16 1 10 1 10C1 10 6.13401 4 10 4C13.866 4 19 10 19 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
    <circle cx="10" cy="10" r="3.5" fill="currentColor" />
    <path d="M10 4L10 0.5" stroke="currentColor" strokeWidth="2" />
    <path d="M14.2109 5L15.4109 1.8" stroke="currentColor" strokeWidth="2" />
    <path d="M5.89062 5L4.69063 1.8" stroke="currentColor" strokeWidth="2" />
    <path d="M17 7L19 5" stroke="currentColor" strokeWidth="2" />
    <path d="M3 7L1 5" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default IconShow;
